import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {UIUrlParameterNames} from '../../../shared/scripts/ui_html/UIUrlController'
import {Sound} from '../../../shared/scripts/Sound'
import {getHomepageUrlWithParameter, navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils'
import {setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'

export class UIWLeaderboardCTAController {
    constructor() {
        const playButtonBaseGame = document.getElementById('leaderboard_play_base_game') as HTMLLinkElement
        const playButton1v1 = document.getElementById('leaderboard_play_1v1') as HTMLLinkElement
        const playButtonCK = document.getElementById('leaderboard_play_c&k') as HTMLLinkElement

        playButtonBaseGame.style.display = 'flex'
        playButton1v1.style.display = 'flex'
        playButtonCK.style.display = 'flex'

        setElementOnClick(playButtonBaseGame, () => {
            Sound.playSound(Sound.SoundType.Click)
            this.actionBaseGame()
        })

        setElementOnClick(playButton1v1, () => {
            Sound.playSound(Sound.SoundType.Click)
            this.action1v1()
        })

        setElementOnClick(playButtonCK, () => {
            Sound.playSound(Sound.SoundType.Click)
            this.actionCK()
        })
    }

    // eslint-disable-next-line class-methods-use-this
    protected actionBaseGame() {
        navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.EnterMatchmaking, MatchmakingMatchTypes.RankedClassic4P))
    }

    // eslint-disable-next-line class-methods-use-this
    protected action1v1() {
        navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.EnterMatchmaking, MatchmakingMatchTypes.RankedClassic1v1))
    }

    // eslint-disable-next-line class-methods-use-this
    protected actionCK() {
        navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.EnterMatchmaking, MatchmakingMatchTypes.RankedCitiesAndKnights4P))
    }
}
